"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosError = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Determines if an error is an axios error. This is basically a pass-through
 * for axios.isAxiosError, except that it doesn't throw an exception if it
 * receives `undefined`.
 */
const isAxiosError = (error) => error ? axios_1.default.isAxiosError(error) : false;
exports.isAxiosError = isAxiosError;
